import React, { useState, useEffect, useContext, useRef } from "react";
import quizThumb from '../assets/images/quiz-default.jpg';
import Footer from "../components/footer/Footer";
import SideMenu from "./student/SideMenu";
import Header from "../components/dashboard/header";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import tmdbApi from "../api/tmdbApi";
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';
import SweetAlert from 'react-bootstrap-sweetalert';
import parse from "react-html-parser";
import { Gallery } from "react-grid-gallery";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { contentContext } from "../context/contentContext";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import "react-lazy-load-image-component/src/effects/blur.css";
import Loader from "../components/loader";
import OpenSeadragon from "openseadragon";
import deepZoom from "../assets/images/icons/Dna-dz.svg";
import rotate_right from '../assets/images/rotate_right.svg';
import { ToastContainer, toast } from 'react-toastify';
import GoogleFormEmbed from "./GoogleFormEmbed";

const ModuleQuiz = ({ type, moduleType = null }) => {
//llkjk
    let { id } = useParams();
    const transformRef = useRef(null);
    const viewerRef = useRef(null);
    const [resetpopup, setresetpopup] = useState(false);
    const [rotation, setRotation] = useState(0);
    const { state } = useLocation();
    const navigate = useNavigate();
    const [cpcQtns, setCpcQtns] = useState(null);
    const [answers, setAnswersData] = useState(null);
    const [qdisplay, setQdisplay] = useState(false);
    const [loader, setLoader] = useState(false);
    const [btnLoader, setBtnLoader] = useState("");
    const [imageCloudfront, setImg] = useState("");
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [popupImage, setPopupImage] = useState("");
    const [isPopupLoading, setPopupLoading] = useState(false);
    const [img, setImage] = useState("");
    const [popup, setPopup] = useState(false)
    const handleClosePopup = () => setPopup(false);
    const [filteredOptions, setFilteredOptions] = useState([]);
    const [activeField, setActiveField] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [isAutoSliding, setIsAutoSliding] = useState(false);
    const [index, setIndex] = useState(-1);
    const [gallery, setGallery] = useState([]);
    const [currentImage, setcurrentImage] = useState(null);
    const [nextIndex, setnextIndex] = useState(null);
    const [nextImage, setnextImage] = useState(null);
    const [prevIndex, setprevIndex] = useState(null);
    const [prevImage, setprevImage] = useState(null);
    // const [isLoading, setIsLoading] = useState(true);

    const [learninguniqueid, setLearninguniqueid] = useState(null);
    const [selected, setSelected] = useState({});
    const [successMsg, setSuccessMsg] = useState(false)
    const [messageTitle, setMessageTitle] = useState("")

    const [handleBackPopup, setHandleBackPopup] = useState(false)
    const [viewer, setViewer] = useState(null);



    const [dziUrl, setDziUrl] = useState("");
    const [dziUrlFile, setDziUrlFile] = useState("");
    const [dzipopupImage, setDZIPopupImage] = useState(false);

    const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });
    const [dragActive, setDragActive] = useState(false);

    const [showImagePopup, setShowImagePopup] = useState(false);
    const [popupPngImage, setPopupPngImage] = useState("");
    const [clinicalPopupList, setClinicalPopupList] = useState([]);
    const [clinicalPopupIndex, setClinicalPopupIndex] = useState(0);
    const [isClinicalLoading, setIsClinicalLoading] = useState(false);
    const [dziImageList, setDziImageList] = useState([]);
    const [dziCurrentIndex, setDziCurrentIndex] = useState(0);
    const [isDziLoading, setIsDziLoading] = useState(false);
    const [confirmPopup, setConfirmPopup] = useState(false);
    const [pendingAction, setPendingAction] = useState(null);

    //     const location = useLocation();
    //   const { moduleType } = location.state || {};
    // const [user, setUser] = useState(null)
    const [showVideoPopup, setShowVideoPopup] = useState(false);
    const [editLinkValue, setEditLinkValue] = useState("");
    const { searchedFlag, setSearchedFlag, isLoading, setIsLoading, userData, setUserData, activeMenuObj, setActiveMenuObj, sortTableAlpha, arrow, usersearch, setUserSearch, currentPage, setcurrentPage, data, setData, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious, setActiveMenuId, GetTimeActivity } = useContext(contentContext)

    const getExtension = (filename) => {

        if (!filename) return null;
        let extType = filename.split('.').pop().toLowerCase();
        let valReturn = ".jpeg,.jpg,.png";
        if (extType === 'tiff' || extType === 'tif') {
            valReturn = ".tif,.tiff";
        }
        return valReturn
    };
    console.log('kirannsnksnsknsnkskn', moduleType)
    useEffect(() => {
        if (!viewerRef.current) return;

        console.log("Loading OpenSeadragon with URL:", dziUrl);
        const isDziURL = dziUrl.includes("output.dzi");
        const { width, height } = imageDimensions; // Destructure imageDimensions for clarity
        const tileSource = isDziURL
            ? {
                Image: {
                    xmlns: "http://schemas.microsoft.com/deepzoom/2008",
                    Url: encodeURI(dziUrl),
                    Format: "jpeg",
                    Overlap: 2,
                    TileSize: 256,
                    Size: { Width: width, Height: height },
                },
            }
            : {
                type: "image",
                url: encodeURI(dziUrl),
                buildPyramid: false,
            };
        const osdViewer = OpenSeadragon({
            id: "openseadragon-viewer",
            prefixUrl: "https://openseadragon.github.io/openseadragon/images/",
            tileSources: tileSource,
            showNavigator: true,
            crossOriginPolicy: false,
            navigatorPosition: "BOTTOM_RIGHT",
            maxZoomPixelRatio: 10,
            minZoomImageRatio: 0.5,
            visibilityRatio: 1,
            zoomPerScroll: 2,
            homeFillsViewer: true,
            gestureSettingsMouse: {
                clickToZoom: true,
                dblClickToZoom: true,
                flickEnabled: true,
                pinchToZoom: true,
                scrollToZoom: true,
            },
            showZoomControl: true,
            showHomeControl: true,
            showFullPageControl: true,
            showRotationControl: true,
            wrapHorizontal: false,
        });

        setViewer(osdViewer);
        osdViewer.addOnceHandler("open", () => setIsDziLoading(false));

        return () => {
            if (osdViewer) {
                osdViewer.destroy();
            }
        };
    }, [dziUrl, imageDimensions]);
    const rotateImage = (angle) => {
        if (viewer) {
            const newRotation = (rotation + angle) % 360;
            viewer.viewport.setRotation(newRotation);
            setRotation(newRotation);
        }
    };
    const handleConfirmSubmit = (e, value) => {
        e.preventDefault(); // ✅ stop form submit

        // Popup ONLY for Fellowship + Submit
        if (moduleType === "FELLOWSHIP" && value === "submit") {
            setPendingAction(value);
            setConfirmPopup(true);
        } else {
            handleSubmit(e, value); // normal flow
        }
    };
    const onConfirmPopup = () => {
        setConfirmPopup(false);
        // handleSubmit(null, pendingAction);
        handleSubmit({ preventDefault: () => { } }, pendingAction);

    };

    const onCancelConfirm = () => {
        setConfirmPopup(false);
        setPendingAction(null);
    };


    const closeDeepZoom = () => {
        setPopupOpen(false);
        setDziUrl("");
        setDziUrlFile("");
        setImageDimensions({ width: 0, height: 0 });
        setDziImageList([]);
        setDziCurrentIndex(0);
        setIsDziLoading(false);
        if (viewer) {
            viewer.destroy();
            setViewer(null);
        }
    };
    useEffect(() => {
        if (gallery) {
            // console.log(gallery, index)
            const currentImage = gallery[index];
            setcurrentImage(currentImage)
            const nextIndex = (index + 1) % gallery.length;
            setnextIndex(nextIndex)
            const nextImage = gallery[nextIndex] || currentImage;
            setnextImage(nextImage)
            const prevIndex = (index + gallery.length - 1) % gallery.length;
            setprevIndex(prevIndex)
            const prevImage = gallery[prevIndex] || currentImage;
            setprevImage(prevImage)
        }

    }, [index]);

    useEffect(() => {
        if (currentImage) {
            const img = new Image();
            img.src = `${imageCloudfront}${currentImage?.sourcepath.replace(/ /g, "%20")}?auto=compress,format`;
            img.onload = () => setIsLoading(false);
        }

    }, [currentImage]);

    useEffect(() => {
        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }
    }, [window.site]);

    const handlePopupload = (e) => {
        setPopupLoading(true)
        console.log(dziUrl, "dz")
    }

    useEffect(() => {
        const selectedLength = Object.keys(selected).length
        if (selectedLength > 0) {
            // Add event listener for popstate to detect when the user presses the back button
            const handlePopState = (event) => {

                // Display the popup
                setHandleBackPopup(true);
                // Prevent default action of going back
                event.preventDefault();
                console.log("Browser back button pressed.");

            };

            // Initially pushState to allow popstate to fire
            window.history.pushState({}, document.title, window.location.href);

            // Add popstate listener
            window.addEventListener("popstate", handlePopState);

            return () => {
                // Cleanup event listener when component unmounts
                window.removeEventListener("popstate", handlePopState);
            };
        }

    }, [selected]);

    useEffect(() => {
        // This function will handle the beforeunload event
        const handleBeforeUnload = (event) => {
            // Prevent the default browser prompt (e.g., "Changes you made may not be saved")
            event.preventDefault();
            // For most browsers to show a confirmation dialog
            event.returnValue = '';  // This triggers the native browser confirmation dialog (which we want to avoid)

            // Show custom popup instead of native browser dialog
            //   setHandleBackPopup(true);
        };

        // Add the event listener for beforeunload (when user attempts to reload/close the page)
        window.addEventListener('beforeunload', handleBeforeUnload);

        // Cleanup on component unmount
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);
    const GetAnswersInfo = async () => {
        try {
            const response = await tmdbApi.answerInfo();
            setAnswersData(response?.result?.answerData);
        } catch {
            console.log("error");
        }
    };

    const [cancel, setCancel] = useState(false)



    const getCaseInfo = async (caseid) => {
        const response = await tmdbApi.cpcCaseMdouleInfo(caseid, type, id);
        let qtns = []
        if (response?.result?.questionData?.length > 0) {
            qtns = response?.result?.questionData.map(qtn => {
                qtn['answers'] = [
                    { id: 1, selected: {}, percent: 0 },
                    { id: 2, selected: {}, percent: 0 },
                    { id: 3, selected: {}, percent: 0 },
                    { id: 4, selected: {}, percent: 0 }
                ]
                return qtn;
            })
            // API doesn't guarantee order; show cases in the order they were sent (module's saved order)
            const sentOrder = (caseid || []).map(String);
            const rank = (qtn) => {
                const i = sentOrder.indexOf(String(qtn?.caseid));
                return i === -1 ? Infinity : i;
            };
            qtns.sort((a, b) => rank(a) - rank(b));
        }
        setVideoUrl(response?.result?.videoLink || null);
        return qtns
    }


    // For each question, track if the extra dropdown is enabled
    const [extraDropdown, setExtraDropdown] = useState({});
    const [filteredOptionsMap, setFilteredOptionsMap] = useState({});

    // Only one or two dropdowns per question
    const handleSelectChange = (qIndex, selectedOption, dropdownIdx = 0) => {
        setActiveField(`${qIndex}_${dropdownIdx}`);
        setSelected(prev => ({
            ...prev,
            [`${qIndex}_${dropdownIdx}`]: selectedOption
        }));

        let rmpQtns = [...cpcQtns];
        // Ensure answers array has at least dropdownIdx+1 slots
        if (!rmpQtns[qIndex].answers) rmpQtns[qIndex].answers = [];
        while (rmpQtns[qIndex].answers.length <= dropdownIdx) {
            rmpQtns[qIndex].answers.push({ id: dropdownIdx + 1, selected: {} });
        }
        rmpQtns[qIndex].answers[dropdownIdx].selected = selectedOption;
        setCpcQtns(rmpQtns);
        // 🔥 REMOVE ERROR FOR THIS QUESTION IMMEDIATELY
        setError(prev =>
            prev.filter(err => !err.includes(`Case ${qIndex + 1}`))
        );
    };

    const handleInputChange = (inputValue, qIndex, dropdownIdx = 0) => {
        setActiveField(`${qIndex}_${dropdownIdx}`);
        if (inputValue !== "") {
            const results = answers.filter(option =>
                option.answer.toLowerCase().includes(inputValue.toLowerCase())
            );
            setFilteredOptionsMap(prev => ({
                ...prev,
                [`${qIndex}_${dropdownIdx}`]: results
            }));
        } else {
            setFilteredOptionsMap(prev => ({
                ...prev,
                [`${qIndex}_${dropdownIdx}`]: []
            }));
        }
    };

    // Modified handlers
    const handleTextInputChange = (qIndex, inputValue, dropdownIdx = 0) => {
        // Create a selectedOption object with the text as both value and label
        const selectedOption = inputValue.trim() !== ""
            ? { value: inputValue, label: inputValue }
            : null;

        setSelected(prev => ({
            ...prev,
            [`${qIndex}_${dropdownIdx}`]: selectedOption
        }));

        let rmpQtns = [...cpcQtns];
        // Ensure answers array has at least dropdownIdx+1 slots
        if (!rmpQtns[qIndex].answers) rmpQtns[qIndex].answers = [];
        while (rmpQtns[qIndex].answers.length <= dropdownIdx) {
            rmpQtns[qIndex].answers.push({ id: dropdownIdx + 1, selected: {} });
        }
        rmpQtns[qIndex].answers[dropdownIdx].selected = selectedOption;
        setCpcQtns(rmpQtns);
        if (selectedOption) {
            setError(prev =>
                prev.filter(err => !err.includes(`Case ${qIndex + 1}`))
            );
        }
    };

    const handleClearInput = (qIndex, dropdownIdx = 0) => {
        setSelected(prev => ({
            ...prev,
            [`${qIndex}_${dropdownIdx}`]: null
        }));

        let rmpQtns = [...cpcQtns];
        if (rmpQtns[qIndex].answers && rmpQtns[qIndex].answers[dropdownIdx]) {
            rmpQtns[qIndex].answers[dropdownIdx].selected = null;
        }
        setCpcQtns(rmpQtns);
    };

    // Checkbox handler to toggle extra dropdown
    const handleExtraDropdownToggle = (qIndex) => {
        setExtraDropdown(prev => ({
            ...prev,
            [qIndex]: !prev[qIndex]
        }));
    };

    const [caseId, setCaseId] = useState(null);
    const [moduleInfo, setModuleInfo] = useState(null);
    const [moduleExpiredPopup, setModuleExpiredPopup] = useState(false);
    const [moduleExpiredMsg, setModuleExpiredMsg] = useState("");
    const getCpcInfoById = async (id) => {
        try {
            let response = await tmdbApi.moduleInfo(id)
            if (typeof response?.result === 'string') {
                setModuleExpiredMsg(response.result);
                setModuleExpiredPopup(true);
                return;
            }
            if (response?.result?.data?.length > 0) {
                setCaseId(response?.result?.data[0]?.cases)
                setModuleInfo(response?.result?.data[0]);
            }
        } catch (err) {
            setError(["Failed to load module info."]);
        }
    }
    console.log('moduleType', moduleType)
    const onCancel = () => {
        localStorage.removeItem("moduleid")
        const module = localStorage.getItem('usermodule')

        // navigate(-1);
        if (moduleType === "Timed Module") {
            navigate('/timedmodule')
        } else if (moduleType === "FELLOWSHIP") {
            navigate('/fellowshipmodules')
        }
        else if (moduleType === "MCQ") {
            navigate('/mcqmoduleslibrary')
        }
        else if (moduleType === "CASE-SUMMARY") {
            navigate('/submitted-modules/' + state?.fellowuserid)
        } else if (moduleInfo?.subscribed === true) {
            navigate('/moduleslibrary');
        }
        else if (moduleInfo?.participated === false && moduleInfo?.purchased === false && moduleInfo?.cost === 0) {
            navigate('/moduleslibrary')
        } else if (module === "usermodule") {
            navigate("/fellowshipmodules")
        } else {
            navigate('/usermoduleslibrary')
        }
    };
    useEffect(() => {
        if (moduleType !== "CASE-SUMMARY") {
            getCpcInfoById(id)
            GetAnswersInfo();
        } else {
            getModuleInfo()
        }

    }, [])




    console.log('fellowuserid', state?.fellowuserid)

    const getModuleInfo = async () => {

        try {
            const percentileRes = await tmdbApi.learningModulePercentile2(id, state?.fellowuserid);
            if (percentileRes?.result) {
                // debugger
                const response = await tmdbApi.moduleInfo(percentileRes.result[0].moduleid);
                if (response?.result && response?.result?.data.length > 0) {
                    let res = { ...response.result?.data[0] };
                    res['percentile'] = percentileRes.result[0].percentile;
                    res['cases'] = percentileRes.result[0].cases;
                    res['moduleScore'] = percentileRes.result[0].moduleScore;
                    console.log(res, "res")
                    setModuleInfo(res);
                }
            }
        } catch (err) {
            setModuleInfo(null);
        }
    };
    const fetchData = async () => {
        setLoader(true)
        try {
            if (caseId?.length > 0) {
                let casid = caseId.map(item => item.value)
                const tmpData = await getCaseInfo(casid)
                setCpcQtns(tmpData.filter(Boolean));
            }
            setQdisplay(true)
        } catch (err) {
            setError(["Failed to load case info."]);
            setQdisplay(true);
        } finally {
            setLoader(false)
        }
    };

    const getUserInfo = async () => {
        let userInfo = await tmdbApi.getUserData();
        if (userInfo?.statusCode === 200 && userInfo?.result?.[0]) {
            // setUser(userInfo?.result?.[0])
        }
    }
    useEffect(() => {

        fetchData();

        // getUserInfo()


    }, [caseId]);


    const customComponents = {
        DropdownIndicator: () => null, // Remove the dropdown indicator
        IndicatorSeparator: () => null, // Optionally remove the separator
    };








    const onReset = (e) => {
        window.scrollTo(0, 0);
        e.preventDefault()
        setresetpopup(true)
        // setSelected({})
    };

    const ErrorList = ({ errors }) => {
        if (!errors || errors.length === 0) {
            return null; // No errors to display
        }

        return (
            <div style={{ color: 'red' }}>
                <ul style={{ display: "block" }}>
                    {errors.map((error, index) => (
                        <li key={index}>{error}</li>
                    ))}
                </ul>
            </div>
        );
    };

    const [error, setError] = useState([])
    const handleSubmit = async (e, value = null) => {
        // Remove percentage validation: only require at least one answer selected per question
        const validated = cpcQtns.map((qtn, index) => {
            const selectedAnswers = qtn.answers.filter(ans =>
                Object.keys(ans.selected || {}).length > 0
            );
            const valid = selectedAnswers.length > 0;
            return {
                caseid: qtn.caseid,
                answers: selectedAnswers,
                title: 'Case ' + (index + 1),
                diagnosis: qtn.diagnosis,
                selectedCount: selectedAnswers.length,
                valid,
                index
            };
        });

        const invalidQuestions = validated.filter(val => !val.valid);
        console.log('moduleTypemoduleTypemoduleTypemoduleType', moduleType)

        if (moduleType === "FELLOWSHIP") {

            // Skip validation ONLY when saving
            if (value === "submit" && invalidQuestions.length > 0) {

                toast.error(`Please answer all cases before submitting.`);

                return;
            }

        } else {
            // Other modules → ALWAYS validate
            if (invalidQuestions.length > 0) {
                const errMessages = invalidQuestions.map(q =>
                    `Question "${q.title}" requires at least one selected option.`
                );
                setError(errMessages);
                return;
            }
        }

        if (
            moduleType === "FELLOWSHIP" &&
            value === "submit" &&
            !confirmPopup
        ) {
            setPendingAction(value);
            setConfirmPopup(true);
            return; // ⛔ stop before API
        }

        // All questions valid → clear errors

        setBtnLoader(value === "save" ? "save" : "submit");


        try {
            let payload = {
                moduleid: id,
                userid: localStorage.getItem("userId"),
                cases: [],
                projection: "clientcase",
            };
            if (moduleType === "FELLOWSHIP" && value !== null) {
                payload.submitted = value === "submit";
            }
            if (moduleType === "FELLOWSHIP" && value === "submit") {
                payload.pathologistid = state?.pathologistid
            }


            validated.forEach((caseData) => {
                let answers = caseData.answers.map(ans => ({
                    answerid: ans?.selected?.value || "",
                    answer: ans?.selected?.label || ""
                }));


                if (
                    moduleType === "FELLOWSHIP" &&
                    value === "save" &&
                    answers.length === 0
                ) {
                    answers = [
                        {
                            answerid: "",
                            answer: ""
                        }
                    ];
                }

                payload.cases.push({
                    caseid: caseData.caseid,
                    answers
                });

                payload["moduleType"] = moduleType;
            });


            const res = await tmdbApi.addLearningcParticipantAnswers(payload);

            if (res.result?.message?.toLowerCase() === "answers submitted successfully") {
                setLearninguniqueid(res?.result?.learninguniqueid);
                if (moduleType === "FELLOWSHIP" && value === "submit") {
                    setSuccessMsg(true);

                    setMessageTitle("Submitted Successfully. The pathologist will review and follow up with you")
                } else if (moduleType === "FELLOWSHIP" && value === "save") {
                    //  setSuccessMsg(true);
                    toast.success("Saved Successfully")
                    setTimeout(() => {
                        navigate('/fellowshipmodules')

                    }, 3000);

                }

                else {
                    setLearninguniqueid(res?.result?.learninguniqueid);
                    setSuccessMsg(true);
                    setMessageTitle("Thank you for your participation.")
                }
            }

        } catch (error) {
            console.error("Submit Error:", error);
            setError(["Something went wrong. Please try again."]);
        } finally {
            // Stop loader always

            setBtnLoader("");
        }
    };


    const refresh = () => {

        // navigate("/modulesresult/" + learninguniqueid);
        if (moduleType === "FELLOWSHIP") {
            navigate("/fellowshipmodules");

        } else {

            navigate("/viewhistory/" + id, {
                state: { learninguniqueid: learninguniqueid, moduleType: moduleType }
            });
            // navigate("/result/" + learninguniqueid, { state: { moduleType: moduleType } });

        }
        setSuccessMsg(false)
    }

    const handleClinicalPopupOpen = (list, index) => {
        setShowImagePopup(true);
        setIsClinicalLoading(true);
        setPopupPngImage(list[index]);
        setClinicalPopupList(list);
        setClinicalPopupIndex(index);
    };

    const navigateClinicalImage = (newIndex) => {
        if (!clinicalPopupList.length) return;
        const clamped = Math.max(0, Math.min(newIndex, clinicalPopupList.length - 1));
        setIsClinicalLoading(true);
        setPopupPngImage(clinicalPopupList[clamped]);
        setClinicalPopupIndex(clamped);
    };

    const buildTileSourceForFile = (file) => {
        let path = file.dziUrl || "";
        if (path.startsWith("/")) path = path.slice(1);
        const isDziURL = path.includes("output.dzi");
        if (isDziURL) {
            path = `${path}_files/`;
            return {
                Image: {
                    xmlns: "http://schemas.microsoft.com/deepzoom/2008",
                    Url: encodeURI(imageCloudfront + path),
                    Format: "jpeg",
                    Overlap: 2,
                    TileSize: 256,
                    Size: { Width: file.width || 0, Height: file.height || 0 },
                },
            };
        }
        const url = encodeURI(`${imageCloudfront}${(file.sourcepath || file.filepath || "").replace(/ /g, "%20")}?auto=compress,format`);
        return { type: "image", url, buildPyramid: false };
    };

    const navigateDziImage = (newIndex) => {
        if (!dziImageList.length) return;
        const clamped = Math.max(0, Math.min(newIndex, dziImageList.length - 1));
        const file = dziImageList[clamped];
        if (!file) return;
        const tileSource = buildTileSourceForFile(file);
        if (viewer) {
            setIsDziLoading(true);
            viewer.open(tileSource);
            viewer.viewport.setRotation(0);
            viewer.addOnceHandler("open", () => setIsDziLoading(false));
        }
        setDziCurrentIndex(clamped);
        setDziUrlFile(file?.originalFilename ? file?.originalFilename : file.filename);
        setDZIPopupImage(imageCloudfront + file.sourcepath);
        setRotation(0);
    };

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (showImagePopup && clinicalPopupList.length > 1) {
                if (e.key === "ArrowLeft") {
                    const ni = Math.max(0, clinicalPopupIndex - 1);
                    setIsClinicalLoading(true);
                    setPopupPngImage(clinicalPopupList[ni]);
                    setClinicalPopupIndex(ni);
                } else if (e.key === "ArrowRight") {
                    const ni = Math.min(clinicalPopupList.length - 1, clinicalPopupIndex + 1);
                    setIsClinicalLoading(true);
                    setPopupPngImage(clinicalPopupList[ni]);
                    setClinicalPopupIndex(ni);
                }
            }
            if (isPopupOpen && dziUrl && dziImageList.length > 1 && viewer) {
                if (e.key === "ArrowLeft") {
                    e.preventDefault();
                    navigateDziImage(dziCurrentIndex - 1);
                } else if (e.key === "ArrowRight") {
                    e.preventDefault();
                    navigateDziImage(dziCurrentIndex + 1);
                }
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [showImagePopup, clinicalPopupIndex, clinicalPopupList, isPopupOpen, dziUrl, dziCurrentIndex, dziImageList, viewer]);


    const onResetConfirm = async (e) => {
        setresetpopup(false)
        setSelected({})
        fetchData();

    }
    const onResetReject = (e) => {
        setresetpopup(false)
        setError([])
    }
    const [playVideo, setPlayVideo] = useState(false);
    const [videoUrl, setVideoUrl] = useState(null);

    const [isAccordionOpen, setIsAccordionOpen] = useState(false);
    const getYouTubeVideoId = (url) => {
        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        const match = url?.match(regExp);
        return match && match[7].length === 11 ? match[7] : null;
    };
    console.log('cpcQtns',cpcQtns)
    return (
        <div id="layout-wrapper" className="module-quiz-db">
            <Header />
            <SideMenu />

            <div className="main-content user-management quiz-page" id="main-content">
                <div className="page-content" id="page-content">
                   
                    <div className="container-fluid" id="container-fluid">
                        <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                            <div className="col-lg-12">
                                <div className="d-flex align-items-start gap-5">
                                    <div className="flex-grow-1 d-grid gap-2">

                                    </div>
                                    <div className="create-quiz-btn" onClick={() => onCancel()}>
                                        Back
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-between flex-wrap case-main-heading">

                                <div className="col-lg-8 col-md-8 col-12">
                                    <h4 className="mb-2 card-title" id="breadcrumb-title">
                                        {moduleInfo?.name}
                                    </h4>
                                    <p className="mb-0" dangerouslySetInnerHTML={{ __html: moduleInfo?.description }}></p>

                                </div>
                                {videoUrl && <>
                                    <div className="col-lg-3 col-md-3 col-12">
                                        <h2 className="quiz-title">Video</h2>

                                        <div className="video-card">
                                            <img src={videoUrl ? `https://img.youtube.com/vi/${getYouTubeVideoId(videoUrl)}/0.jpg` : `https://img.youtube.com/vi/0.jpg`} alt="Thumbnail" />
                                            <button className="play-btn" >
                                                <span className="material-symbols-outlined" style={{ cursor: "pointer" }}
                                                    onClick={() => setShowVideoPopup(true)}>
                                                    play_arrow
                                                </span>
                                            </button>
                                        </div>

                                    </div>
                                    <div className="cpcquiz-line1"></div>
                                </>}
                            </div>


                        </div>
 {moduleType === "MCQ" 
 ? <GoogleFormEmbed embededUrl={moduleInfo?.googleFormUrl}/> 
 
 :
                        <div className="row table-data">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-body cpc-management">

                                        <div className="wrapper client_wrapper mt-3 pt-3">
                                            <div className="wrapper quiz_page">


                                                <div className="question_block quiz-page">



                                                    {loader ? <Loader /> :
                                                        qdisplay && cpcQtns && (
                                                            <div className="mb-4">
                                                                {cpcQtns.map((item, qIndex) => (
                                                                    <div key={qIndex} className="mb-4 case-block">
                                                                        <div className=" cpcquiz-ques">
                                                                            <div className="row justify-content-between align-items-start col-lg-12 quiz-ques-img-case">
                                                                                <div className="d-flex flex-column col-lg-8 quiz-ques-sect">
                                                                                    <h3 className="col-lg-12 quiz-title">Case {qIndex + 1}  </h3>
                                                                                    <p className="col-lg-12 quiz-para" dangerouslySetInnerHTML={{ __html: item?.clinicalhistory }} />
                                                                                    <div>
                                                                                        {/* Checkbox to add extra dropdown */}

                                                                                        {moduleType !== "FELLOWSHIP" &&
                                                                                            <div style={{ marginBottom: "10px" }}>
                                                                                                <input
                                                                                                    type="checkbox"
                                                                                                    id={`extra-dropdown-${qIndex}`}
                                                                                                    checked={!!extraDropdown[qIndex]}
                                                                                                    onChange={() => handleExtraDropdownToggle(qIndex)}
                                                                                                />
                                                                                                <label htmlFor={`extra-dropdown-${qIndex}`} style={{ marginLeft: 8 }}>
                                                                                                    This case has multiple diagnosis
                                                                                                </label>
                                                                                            </div>
                                                                                        }
                                                                                        {moduleType === "FELLOWSHIP" ?

                                                                                            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>
                                                                                                <div style={{ position: "relative", flex: 1 }}>
                                                                                                    <textarea
                                                                                                        type="text"
                                                                                                        className="text-input module-quiz-textarea"
                                                                                                        placeholder="Type your answer"
                                                                                                        value={selected[`${qIndex}_0`]?.label || ""}
                                                                                                        onChange={(e) => handleTextInputChange(qIndex, e.target.value, 0)}
                                                                                                        style={{
                                                                                                            width: "100%",
                                                                                                            padding: "8px 30px 8px 8px",
                                                                                                            borderRadius: "4px",
                                                                                                            fontSize: "14px"
                                                                                                        }}
                                                                                                    />
                                                                                                    {selected[`${qIndex}_0`] && (
                                                                                                        <button
                                                                                                            onClick={() => handleClearInput(qIndex, 0)}
                                                                                                            style={{
                                                                                                                position: "absolute",
                                                                                                                right: "8px",
                                                                                                                top: "50%",
                                                                                                                transform: "translateY(-50%)",
                                                                                                                background: "none",
                                                                                                                border: "none",
                                                                                                                cursor: "pointer",
                                                                                                                fontSize: "16px",
                                                                                                                color: "#999"
                                                                                                            }}
                                                                                                            title="Clear"
                                                                                                        >
                                                                                                            ×
                                                                                                        </button>
                                                                                                    )}
                                                                                                </div>
                                                                                            </div>
                                                                                            : <>


                                                                                                <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>
                                                                                                    <Select
                                                                                                        className="select"
                                                                                                        isMulti={false}
                                                                                                        placeholder="Type Answer and Select"
                                                                                                        onChange={(option) => handleSelectChange(qIndex, option, 0)}
                                                                                                        onInputChange={(value) => handleInputChange(value, qIndex, 0)}

                                                                                                        options={removeDuplicateAnswers(
                                                                                                            (filteredOptionsMap[`${qIndex}_0`] || [])
                                                                                                                // filter out answer currently picked in dropdown 1
                                                                                                                .filter(opt => selected[`${qIndex}_1`]?.value !== `${opt.answerid}`)
                                                                                                                .map(eachItem => ({
                                                                                                                    value: `${eachItem.answerid}`,
                                                                                                                    label: eachItem.answer,
                                                                                                                }))
                                                                                                        )}
                                                                                                        isClearable
                                                                                                        value={selected[`${qIndex}_0`] || null}
                                                                                                        menuIsOpen={
                                                                                                            activeField === `${qIndex}_0` &&
                                                                                                            filteredOptionsMap[`${qIndex}_0`]?.length > 0
                                                                                                        }
                                                                                                        components={customComponents}
                                                                                                    />
                                                                                                </div>
                                                                                                {/* Extra dropdown if checkbox checked */}
                                                                                                {extraDropdown[qIndex] && (
                                                                                                    <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>
                                                                                                        <Select
                                                                                                            className="select"
                                                                                                            isMulti={false}
                                                                                                            placeholder="Type Answer and Select"
                                                                                                            onChange={(option) => handleSelectChange(qIndex, option, 1)}
                                                                                                            onInputChange={(value) => handleInputChange(value, qIndex, 1)}
                                                                                                            // options={removeDuplicateAnswers(
                                                                                                            //     filteredOptionsMap[`${qIndex}_1`]?.map((eachItem) => ({
                                                                                                            //         value: `${eachItem.answerid}`,
                                                                                                            //         label: eachItem.answer,
                                                                                                            //     })) || []
                                                                                                            // )}
                                                                                                            options={removeDuplicateAnswers(
                                                                                                                (filteredOptionsMap[`${qIndex}_1`] || [])
                                                                                                                    // filter out answer currently picked in dropdown 0
                                                                                                                    .filter(opt => selected[`${qIndex}_0`]?.value !== `${opt.answerid}`)
                                                                                                                    .map(eachItem => ({
                                                                                                                        value: `${eachItem.answerid}`,
                                                                                                                        label: eachItem.answer,
                                                                                                                    }))
                                                                                                            )}
                                                                                                            isClearable
                                                                                                            value={selected[`${qIndex}_1`] || null}
                                                                                                            menuIsOpen={
                                                                                                                activeField === `${qIndex}_1` &&
                                                                                                                filteredOptionsMap[`${qIndex}_1`]?.length > 0
                                                                                                            }
                                                                                                            components={customComponents}
                                                                                                        />
                                                                                                    </div>
                                                                                                )}
                                                                                            </>
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-lg-4 quiz-img-section">
                                                                                    <div className="quiz-img">



                                                                                        {/* <div style={{ position: "relative", width: "80%", maxWidth: "800px" }}>
                                                                                            <iframe
                                                                                                width="100%"
                                                                                                height="450"
                                                                                                src={`https://www.youtube.com/embed/${getYouTubeVideoId(
                                                                                                    item?.videoLink
                                                                                                )}`}
                                                                                                frameBorder="0"
                                                                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                                                                allowFullScreen
                                                                                                title="Video Preview"
                                                                                            ></iframe>
                                                                                            <button className="create-quiz-btn"
                                                                                                onClick={() => setShowVideoPopup(false)}
                                                                                                style={{
                                                                                                    position: "absolute",
                                                                                                    top: 10,
                                                                                                    right: 10,
                                                                                                    border: "none",
                                                                                                    cursor: "pointer",
                                                                                                }}
                                                                                            >
                                                                                                Close
                                                                                            </button>
                                                                                        </div> */}
                                                                                    </div>
                                                                                    <div className={item?.files?.length > 0 ? "quiz_info content" : "quiz_info no-image content"}>

                                                                                        <div className="d-grid justify-content-start gap-2 align-items-center">
                                                                                            <div className="img-wrapper">
                                                                                                {item?.files && item?.files.length > 0 && <p className="mt-2">Histological Photos</p>}
                                                                                                <div className="img_block d-flex mod-lib-clinic-history-img cpc-info-img-wrapper"> {item?.files?.map((file, fileIndex) => (
                                                                                                    <div key={fileIndex}

                                                                                                        className={`img me-2 ${!file?.thumbnailUrl ? 'upload-static-img' : ''}`}
                                                                                                        onClick={(e) => {
                                                                                                            let filepath = file?.sourcepath || file?.filepath || "";
                                                                                                            let imagePath = `${imageCloudfront}${filepath && filepath?.replace(/ /g, "%20")}?auto=compress,format`

                                                                                                            setPopupOpen(true);
                                                                                                            setImageDimensions({ width: file.width, height: file.height });
                                                                                                            setDziImageList(item?.files || []);
                                                                                                            setDziCurrentIndex(fileIndex);

                                                                                                            let path = file.dziUrl || "";
                                                                                                            if (path.startsWith("/")) path = path.slice(1);
                                                                                                            let isDziURL = path.includes("output.dzi");
                                                                                                            if (isDziURL) {
                                                                                                                path = `${path}_files/`;
                                                                                                                setDziUrl(imageCloudfront + path);
                                                                                                            } else {
                                                                                                                setDziUrl(imagePath);
                                                                                                            }

                                                                                                            setDziUrlFile(file?.originalFilename ? file?.originalFilename : file.filename)
                                                                                                            setDZIPopupImage(imageCloudfront + file.sourcepath);
                                                                                                            handlePopupload(e);

                                                                                                        }}
                                                                                                    >
                                                                                                        <span className="material-symbols-outlined img_view">zoom_out_map</span>

                                                                                                        {/* <span className={`default-img deep-zoom ${!file?.thumbnailUrl ? 'default-static-img' : ''}`}><img src={file?.thumbnailUrl ? `${imageCloudfront?.replace(/\/$/, "")}${file?.thumbnailUrl.replace(/ /g, '%20')}?auto=compress,format&width=150` : deepZoom} alt={file?.originalFilename} /></span> */}
                                                                                                        <span className="default-img">

                                                                                                            <img src={file?.thumbnailUrl ? imageCloudfront?.replace(/\/$/, "") + file?.thumbnailUrl + "?auto=compress,format&width=150" : (

                                                                                                                file?.sourcepath ? `${imageCloudfront}${file?.sourcepath && file?.sourcepath?.replace(/ /g, "%20")}?auto=compress,format` : deepZoom
                                                                                                            )} alt={file?.originalFilename}
                                                                                                            onError={(e) => {
                                                                                                                e.currentTarget.onerror = null;
                                                                                                                e.currentTarget.src = deepZoom;
                                                                                                            }} />

                                                                                                        </span>
                                                                                                    </div>

                                                                                                ))}</div>

                                                                                            </div>

                                                                                            <div className="img-wrapper">
                                                                                                {item?.historyfiles && item?.historyfiles.length > 0 &&
                                                                                                    <p>Clinical History Photos</p>}
                                                                                                <div className="img_block d-flex mod-lib-clinic-history-img cpc-info-img-wrapper">
                                                                                                    {item?.historyfiles && item?.historyfiles.length > 0 && item?.historyfiles?.map((file, key) => {

                                                                                                        let imagePath = `${imageCloudfront}${file?.sourcepath && file?.sourcepath.replace(/ /g, "%20")}?auto=compress,format`

                                                                                                        return (

                                                                                                            <div
                                                                                                                key={key}
                                                                                                                className={`img me-2 ${!file?.thumbnailUrl ? 'upload-static-img' : ''}`}
                                                                                                                style={{ width: 'auto' }}
                                                                                                                onClick={() => {
                                                                                                                const list = (item?.historyfiles || []).map(f => `${imageCloudfront}${f?.sourcepath?.replace(/ /g, "%20")}?auto=compress,format`);
                                                                                                                handleClinicalPopupOpen(list, key);
                                                                                                            }}
                                                                                                            >
                                                                                                                <span className="material-symbols-outlined img_view img-zoom">zoom_out_map</span>
                                                                                                                <img
                                                                                                                    src={`${imageCloudfront}${file?.sourcepath?.replace(/ /g, "%20")}?auto=compress,format&width=125`}
                                                                                                                    alt={`Image ${key + 1}`}
                                                                                                                    loading="lazy"
                                                                                                                />
                                                                                                            </div>


                                                                                                        )
                                                                                                    })}
                                                                                                </div>
                                                                                            </div>

                                                                                            <div className="cpcquiz-line">
                                                                                            </div>
                                                                                        </div>

                                                                                    </div>
                                                                                </div>

                                                                            </div>

                                                                            {/* {userData && userData?.subscriptionplanid && <div>
                                                                                <div className="module-case-discussion p-0 mt-2 me-4">

                                                                                    <div>
                                                                                        <div className="accordion accordion-flush" id="accordionFlushExample">
                                                                                            <div className="accordion-item">
                                                                                                <h2 className="accordion-header" id="flush-headingOne">
                                                                                                    <button
                                                                                                        className={`accordion-button${isAccordionOpen ? '' : ' collapsed'}`}
                                                                                                        type="button"
                                                                                                        aria-expanded={isAccordionOpen}
                                                                                                        aria-controls="flush-collapseOne"
                                                                                                        onClick={() => setIsAccordionOpen(!isAccordionOpen)}
                                                                                                    >
                                                                                                        Case Discussion <span className="ms-2 case-duss-count">case-1 </span>
                                                                                                    </button>
                                                                                                </h2>
                                                                                                <div
                                                                                                    id="flush-collapseOne"
                                                                                                    className={`accordion-collapse collapse${isAccordionOpen ? ' show' : ''}`}
                                                                                                    aria-labelledby="flush-headingOne"
                                                                                                    data-bs-parent="#accordionFlushExample"
                                                                                                >
                                                                                                    {isAccordionOpen && (
                                                                                                        <div className="accordion-body col-lg-12">
                                                                                                            <div className="user-comment d-flex text-start">
                                                                                                                <div className="">The skin is the largest organ of the human body, performing essential functions to maintain homeostasis and protect the internal structures. It serves as a barrier between the body</div>
                                                                                                            </div>
                                                                                                            <div className="admin-comment d-flex">
                                                                                                                <div className="admin-comment-msg">The skin is the largest organ of the human body, performing essential functions to maintain homeostasis and protect the internal structures. It serves as a barrier between the body</div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    )}
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>

                                                                                </div>
                                                                                {isAccordionOpen && (<div className="col-lg-12 col-md-12 mt-2">
                                                                                    <div className="mb-3 input-field me-4">
                                                                                        <label className="form_label">Enter Your Discussion Here<span className="required"></span></label>
                                                                                        <textarea className="form-control mt-1 me-5" id="description" type="text" aria-invalid="false" rows="3" cols="3" name="description" placeholder="Enter Your Discussion Here"></textarea>
                                                                                    </div>
                                                                                    <div className="d-flex justify-content-end me-4">
                                                                                        <button type="submit" className="create-quiz-btn border-0">Send</button>

                                                                                    </div>
                                                                                </div>)}
                                                                            </div>} */}
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )
                                                    }
                                                    {error.length > 0 && moduleType !== "FELLOWSHIP" && <ErrorList errors={error} />}
                                                    <div className="btns quiz-form-btns">
                                                        {moduleType === "FELLOWSHIP" && <button type="submit" className="create-quiz-btn border-0 mr-10" onClick={(e) => handleSubmit(e, 'save')}>
                                                            {btnLoader === "save" && (
                                                                <img src={rotate_right} className="loading-icon me-2" id="loginPwdLoading" alt="loading" />
                                                            )}

                                                            Save as draft</button>}
                                                        <button type="submit" className="create-quiz-btn border-0 mr-10" onClick={(e) => handleSubmit(e, 'submit')}>
                                                            {/* <button
                                                            type="submit"
                                                            className="create-quiz-btn border-0 mr-10"
                                                            onClick={(e) => handleConfirmSubmit(e, 'submit')}
                                                        > */}

                                                            {btnLoader === "submit" && (
                                                                <img src={rotate_right} className="loading-icon me-2" id="loginPwdLoading" alt="loading" />
                                                            )}

                                                            Submit</button>
                                                        <button type="submit" className="fw-normal outline_btn reset-quiz-btn mr-10" onClick={(e) => onReset(e)}>Reset</button>
                                                        <button type="submit" className="fw-normal outline_btn reset-quiz-btn mr-10" onClick={(e) => setCancel(true)}>Cancel</button>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                </div>
                <Footer />
            </div>

            {isPopupOpen && !dziUrl && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 999,
                    }}
                    onClick={() => setPopupOpen(false)}
                >
                    <div className="popup_wrp"
                        style={{
                            position: "relative",
                            background: "white",
                            padding: "10px",
                            borderRadius: "10px",
                            maxWidth: "90vw",
                            maxHeight: "90vh",

                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Close Button */}
                        <button
                            style={{
                                position: "absolute",
                                top: 10,
                                right: 10,
                                background: "white",
                                color: "#000",
                                border: "none",

                                cursor: "pointer",
                                borderRadius: "5px",
                            }}
                            onClick={() => setPopupOpen(false)}
                        >
                            <span className="material-symbols-outlined">
                                X
                            </span>
                        </button>

                        {/* Zoomable Image */}
                        <TransformWrapper ref={transformRef} initialScale={1}>
                            <div style={{ textAlign: "left", marginBottom: "10px" }}>
                                <button onClick={() => transformRef.current.zoomIn()} className="btnzoom" ><span className="material-symbols-outlined"> add </span></button>
                                <button onClick={() => transformRef.current.zoomOut()} className="btnzoom"><span className="material-symbols-outlined"> remove </span></button>
                                <button onClick={() => transformRef.current.resetTransform()} className="btnzoom"><span className="material-symbols-outlined"> refresh </span></button>
                            </div>

                            <TransformComponent>


                                {isPopupLoading && <div style={{ width: "400px", height: "400px" }}><Loader /> </div>}

                                <LazyLoadImage
                                    src={popupImage + `? auto = compress, format`}
                                    effect="blur"
                                    onLoad={() => setPopupLoading(false)}
                                    style={{ width: "100%", borderRadius: "10px" }}
                                    alt="Popup Image"
                                />

                            </TransformComponent>
                        </TransformWrapper>
                    </div>
                </div>
            )}

            {/* Deep Zoom Popup */}
            {isPopupOpen && dziUrl && (
                <div className="deep_zoom">
                    <div
                        style={{
                            position: "fixed",
                            top: '0',
                            left: '0',
                            right: '0',
                            bottom: '0',
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 999,
                            borderRadius: "18px"
                        }}
                    >
                        <div style={{
                            width: "98vw",
                            height: "98vh",
                            position: "relative",
                            backgroundColor: "black",
                            overflow: "hidden"
                        }}>
                            {/* Deep Zoom Header */}
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "0 20px",
                                height: "52px",
                                background: "linear-gradient(135deg, #091918 0%, #215250 100%)",
                                borderBottom: "1px solid rgba(255,255,255,0.08)",
                                boxShadow: "0 2px 12px rgba(0,0,0,0.4)",
                            }}>
                                <div style={{ width: "120px" }} />

                                {dziImageList.length > 1 ? (
                                    <div style={{
                                        display: "flex", alignItems: "center",
                                        background: "rgba(255,255,255,0.07)",
                                        border: "1px solid rgba(255,255,255,0.15)",
                                        borderRadius: "30px", padding: "3px",
                                    }}>
                                        <button
                                            onClick={() => navigateDziImage(dziCurrentIndex - 1)}
                                            disabled={dziCurrentIndex === 0}
                                            title="Previous image (←)"
                                            style={{
                                                border: "none",
                                                background: dziCurrentIndex === 0 ? "transparent" : "rgba(255,255,255,0.1)",
                                                color: dziCurrentIndex === 0 ? "rgba(255,255,255,0.25)" : "#ffffff",
                                                cursor: dziCurrentIndex === 0 ? "not-allowed" : "pointer",
                                                width: "34px", height: "34px", borderRadius: "50%",
                                                display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
                                            }}
                                        >
                                            <span className="material-symbols-outlined" style={{ fontSize: "20px", lineHeight: 1 }}>chevron_left</span>
                                        </button>
                                        <span style={{
                                            display: "flex", alignItems: "center", gap: "4px",
                                            padding: "0 12px", fontSize: "13px", fontWeight: "600",
                                            userSelect: "none", whiteSpace: "nowrap",
                                        }}>
                                            <span style={{ color: "#EA7F4A", fontWeight: "700" }}>{dziCurrentIndex + 1}</span>
                                            <span style={{ color: "rgba(255,255,255,0.35)", fontSize: "11px", margin: "0 1px" }}>/</span>
                                            <span style={{ color: "rgba(255,255,255,0.6)" }}>{dziImageList.length}</span>
                                        </span>
                                        <button
                                            onClick={() => navigateDziImage(dziCurrentIndex + 1)}
                                            disabled={dziCurrentIndex === dziImageList.length - 1}
                                            title="Next image (→)"
                                            style={{
                                                border: "none",
                                                background: dziCurrentIndex === dziImageList.length - 1 ? "transparent" : "rgba(255,255,255,0.1)",
                                                color: dziCurrentIndex === dziImageList.length - 1 ? "rgba(255,255,255,0.25)" : "#ffffff",
                                                cursor: dziCurrentIndex === dziImageList.length - 1 ? "not-allowed" : "pointer",
                                                width: "34px", height: "34px", borderRadius: "50%",
                                                display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
                                            }}
                                        >
                                            <span className="material-symbols-outlined" style={{ fontSize: "20px", lineHeight: 1 }}>chevron_right</span>
                                        </button>
                                    </div>
                                ) : <div />}

                                <div style={{ width: "120px", display: "flex", justifyContent: "flex-end" }}>
                                    <button
                                        className="dz_close"
                                        onClick={closeDeepZoom}
                                        title="Close"
                                        style={{
                                            border: "1px solid rgba(255,255,255,0.15)",
                                            background: "rgba(255,255,255,0.07)",
                                            color: "#ffffff", borderRadius: "50%",
                                            width: "34px", height: "34px",
                                            display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer",
                                        }}
                                    >
                                        <span className="material-symbols-outlined" style={{ fontSize: "18px", lineHeight: 1 }}>close</span>
                                    </button>
                                </div>
                            </div>

                            {/* Deep Zoom Viewer Container */}
                            <div style={{
                                height: "calc(95vh - 80px)",
                                width: "100%",
                                position: "relative"
                            }}>
                                <div
                                    id="openseadragon-viewer"
                                    ref={viewerRef}
                                    style={{
                                        height: "100%",
                                        width: "100%"
                                    }}
                                />

                                {isDziLoading && (
                                    <div style={{
                                        position: "absolute", inset: 0,
                                        display: "flex", alignItems: "center", justifyContent: "center",
                                        background: "rgba(0,0,0,0.55)", zIndex: 20, pointerEvents: "none",
                                    }}>
                                        <div style={{
                                            width: "52px", height: "52px", borderRadius: "50%",
                                            border: "4px solid rgba(255,255,255,0.15)",
                                            borderTopColor: "#EA7F4A",
                                            animation: "dz-spin 0.75s linear infinite",
                                        }} />
                                        <style>{`@keyframes dz-spin { to { transform: rotate(360deg); } }`}</style>
                                    </div>
                                )}

                                <div style={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    color: "grey",
                                    fontSize: "2vw",
                                    fontWeight: "600",
                                    textTransform: "uppercase",
                                    letterSpacing: "2px",
                                    textShadow: "1px 1px 4px rgba(0,0,0,0.6)",
                                    pointerEvents: "none",
                                    zIndex: 10,
                                    userSelect: "none"
                                }}>
                                    Copyright © 2026 DADI
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}


            <SweetAlert
                show={successMsg}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={messageTitle}
                onConfirm={e => refresh()}
                id="error-alert"
            ></SweetAlert>


            <SweetAlert
                show={moduleExpiredPopup}
                warning
                confirmBtnText="OK"
                confirmBtnBsStyle="primary"
                title={moduleExpiredMsg || "Module access has expired"}
                onConfirm={() => {
                    setModuleExpiredPopup(false);
                    navigate('/mcqmoduleslibrary');
                }}
            />

            <SweetAlert
                show={cancel}
                warning
                showCancel
                confirmBtnText="Yes"
                cancelBtnText="Cancel"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title="Are you sure want to close?"
                focusCancelBtn
                onConfirm={e => onCancel()}
                onCancel={e => setCancel(false)}
            >
            </SweetAlert>

            <SweetAlert show={resetpopup}
                warning
                showCancel
                confirmBtnText="Yes"
                cancelBtnText="Cancel"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title={`${moduleType === "FELLOWSHIP" ? "Are you sure to reset the answers?" : "Are you sure to reset the Quiz?"}`}
                focusCancelBtn
                onConfirm={e => onResetConfirm()}
                onCancel={e => onResetReject()}
            ></SweetAlert>
            <SweetAlert
                show={confirmPopup}
                warning
                showCancel
                confirmBtnText="Yes"
                cancelBtnText="Cancel"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title="Are you sure you want to submit this module? It cannot be modified after submission."
                focusCancelBtn
                onConfirm={onConfirmPopup}
                onCancel={onCancelConfirm}
            />


            {showImagePopup && (
                <div
                    style={{
                        position: "fixed", top: 0, left: 0,
                        width: "100%", height: "100%",
                        backgroundColor: "rgba(0,0,0,0.88)",
                        zIndex: 1003, display: "flex", flexDirection: "column",
                    }}
                    onClick={() => setShowImagePopup(false)}
                >
                    {/* Header */}
                    <div
                        style={{
                            display: "flex", justifyContent: "space-between", alignItems: "center",
                            padding: "0 20px", height: "52px", flexShrink: 0,
                            background: "linear-gradient(135deg, #091918 0%, #215250 100%)",
                            borderBottom: "1px solid rgba(255,255,255,0.08)",
                            boxShadow: "0 2px 12px rgba(0,0,0,0.4)",
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div style={{ width: "120px" }} />
                        {clinicalPopupList.length > 1 ? (
                            <div style={{
                                display: "flex", alignItems: "center",
                                background: "rgba(255,255,255,0.07)",
                                border: "1px solid rgba(255,255,255,0.15)",
                                borderRadius: "30px", padding: "3px",
                            }}>
                                <button
                                    onClick={() => navigateClinicalImage(clinicalPopupIndex - 1)}
                                    disabled={clinicalPopupIndex === 0}
                                    title="Previous image (←)"
                                    style={{
                                        border: "none",
                                        background: clinicalPopupIndex === 0 ? "transparent" : "rgba(255,255,255,0.1)",
                                        color: clinicalPopupIndex === 0 ? "rgba(255,255,255,0.25)" : "#ffffff",
                                        cursor: clinicalPopupIndex === 0 ? "not-allowed" : "pointer",
                                        width: "34px", height: "34px", borderRadius: "50%",
                                        display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
                                    }}
                                >
                                    <span className="material-symbols-outlined" style={{ fontSize: "20px", lineHeight: 1 }}>chevron_left</span>
                                </button>
                                <span style={{
                                    display: "flex", alignItems: "center", gap: "4px",
                                    padding: "0 12px", fontSize: "13px", fontWeight: "600",
                                    userSelect: "none", whiteSpace: "nowrap",
                                }}>
                                    <span style={{ color: "#EA7F4A", fontWeight: "700" }}>{clinicalPopupIndex + 1}</span>
                                    <span style={{ color: "rgba(255,255,255,0.35)", fontSize: "11px", margin: "0 1px" }}>/</span>
                                    <span style={{ color: "rgba(255,255,255,0.6)" }}>{clinicalPopupList.length}</span>
                                </span>
                                <button
                                    onClick={() => navigateClinicalImage(clinicalPopupIndex + 1)}
                                    disabled={clinicalPopupIndex === clinicalPopupList.length - 1}
                                    title="Next image (→)"
                                    style={{
                                        border: "none",
                                        background: clinicalPopupIndex === clinicalPopupList.length - 1 ? "transparent" : "rgba(255,255,255,0.1)",
                                        color: clinicalPopupIndex === clinicalPopupList.length - 1 ? "rgba(255,255,255,0.25)" : "#ffffff",
                                        cursor: clinicalPopupIndex === clinicalPopupList.length - 1 ? "not-allowed" : "pointer",
                                        width: "34px", height: "34px", borderRadius: "50%",
                                        display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
                                    }}
                                >
                                    <span className="material-symbols-outlined" style={{ fontSize: "20px", lineHeight: 1 }}>chevron_right</span>
                                </button>
                            </div>
                        ) : <div />}
                        <div style={{ width: "120px", display: "flex", justifyContent: "flex-end" }}>
                            <button
                                className="dz_close"
                                onClick={() => setShowImagePopup(false)}
                                title="Close"
                                style={{
                                    border: "1px solid rgba(255,255,255,0.15)",
                                    background: "rgba(255,255,255,0.07)",
                                    color: "#ffffff", borderRadius: "50%",
                                    width: "34px", height: "34px",
                                    display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer",
                                }}
                            >
                                <span className="material-symbols-outlined" style={{ fontSize: "18px", lineHeight: 1 }}>close</span>
                            </button>
                        </div>
                    </div>
                    {/* Image area */}
                    <div
                        style={{
                            flex: 1, position: "relative",
                            display: "flex", alignItems: "center", justifyContent: "center",
                            padding: "20px", overflow: "hidden",
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {isClinicalLoading && (
                            <div style={{
                                position: "absolute", inset: 0,
                                display: "flex", alignItems: "center", justifyContent: "center",
                                background: "rgba(0,0,0,0.55)", zIndex: 20, pointerEvents: "none",
                            }}>
                                <div style={{
                                    width: "52px", height: "52px", borderRadius: "50%",
                                    border: "4px solid rgba(255,255,255,0.15)",
                                    borderTopColor: "#EA7F4A",
                                    animation: "dz-spin 0.75s linear infinite",
                                }} />
                                <style>{`@keyframes dz-spin { to { transform: rotate(360deg); } }`}</style>
                            </div>
                        )}
                        <img
                            src={popupPngImage}
                            onLoad={() => setIsClinicalLoading(false)}
                            onError={() => setIsClinicalLoading(false)}
                            style={{
                                maxWidth: "100%", maxHeight: "100%",
                                objectFit: "contain", display: "block", borderRadius: "4px",
                                opacity: isClinicalLoading ? 0 : 1,
                                transition: "opacity 0.2s ease",
                            }}
                        />
                    </div>
                </div>
            )}
            <ToastContainer
                id="toastContainer"
                position="bottom-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />

            {showVideoPopup && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0,0,0,0.8)",
                        zIndex: 1000,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                    onClick={() => setShowVideoPopup(false)}
                >
                    <div style={{ position: "relative", width: "80%", maxWidth: "800px" }}>
                        <iframe
                            width="100%"
                            height="450"
                            src={`https://www.youtube.com/embed/${getYouTubeVideoId(
                                videoUrl
                            )}`}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            title="Video Preview"
                        ></iframe>
                        <button className="create-quiz-btn"
                            onClick={() => setShowVideoPopup(false)}
                            style={{
                                position: "absolute",
                                top: 10,
                                right: 10,
                                border: "none",
                                cursor: "pointer",
                            }}
                        >
                            X
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

const removeDuplicateAnswers = (options) => {
    const uniqueOptions = [];
    const seen = new Set();

    options.forEach((option) => {
        if (!seen.has(option.value)) {
            uniqueOptions.push(option);
            seen.add(option.value);
        }
    });

    return uniqueOptions;
};

export default ModuleQuiz;